import { useState, useEffect } from 'react';
import { Events } from 'react-scroll';
import { ModernStickyHeader } from './components/ModernStickyHeader';
import { HomeSophisticated } from './pages/HomeSophisticated';

function App() {
  const [, setCurrentSection] = useState('home');

  // Homepage navigation links (hash-based for sections)
  const homepageNavLinks = [
    { label: 'Home', href: '#home' },
    { label: 'Projects', href: '#work' },
    { label: 'Blog', href: '#writing' },
    { label: 'Contact', href: '#contact' },
  ];

  useEffect(() => {
    // Handle hash navigation on page load
    const handleHashNavigation = () => {
      const hash = window.location.hash;
      if (hash) {
        // Wait for the page to render, then scroll to the section
        setTimeout(() => {
          if (hash === '#contact') {
            // Special handling for contact - scroll to bottom
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: 'smooth'
            });
          } else {
            const element = document.querySelector(hash);
            if (element) {
              const offset = 80; // Account for sticky header
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;
              
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }
        }, 100);
      } else {
        // Only scroll to top if there's no hash
        window.scrollTo(0, 0);
      }
    };

    handleHashNavigation();
    
    // Handle hash changes (when navigating within the same page)
    const handleHashChange = () => {
      handleHashNavigation();
    };

    window.addEventListener('hashchange', handleHashChange);
    
    Events.scrollEvent.register('begin', () => {});
    Events.scrollEvent.register('end', (to) => {
      setCurrentSection(to);
    });

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  return (
    <div className="min-h-screen text-gray-900 dark:text-white transition-colors duration-200">
      <ModernStickyHeader navLinks={homepageNavLinks} />
      <main className="pt-18">
        <HomeSophisticated />
      </main>
    </div>
  );
}

export default App;